import classNames from "classnames"
import { useAppSelector } from "integrations/redux/hooks"
import { selectIsLocationOverrideSubmitting } from "features/overview/slice"
import * as Icons from "@nova/component-icons"

export const LocationOverrideCrosshair = () => {
    const isSubmitting = useAppSelector(selectIsLocationOverrideSubmitting)
    return (
        <div
            className={classNames(
                "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none transition-opacity",
                { "opacity-50": isSubmitting }
            )}
        >
            <Icons.CustomIcon
                Icon={Icons.Target}
                size={{ width: 36, height: 36 }}
                style={{ color: "#27BBFF" }}
            />
        </div>
    )
}
